import { AccionesPropuestaComponent } from './../acciones-propuesta/acciones-propuesta.component';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent, Sort, MatTableDataSource, MatSort, MatExpansionPanel, MatDialog, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { VolverService } from '../../../providers/volver.service';
import { PropuestasService } from '../../../providers/propuestas.service';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { ClienteService } from '../../../providers/cliente.service';
import { DialogAccionesPropuesta } from '../acciones-propuesta/acciones-propuesta.component';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-listado-propuestas',
  templateUrl: './listado-propuestas.component.html',
  styleUrls: ['./listado-propuestas.component.scss']
})
export class ListadoPropuestasComponent implements OnInit {
  readonly titulo = 'Propuestas';
  columnas = [
    // 'IdPropuesta',
    'PropuestaNombre',
    'propuestaEstado',
    'flujo',
    'PropuestaCurso',
    'EntidadRazonSocial',
    'ContactoNombre',
    'productos',
    'observaciones',
    'PropuestaFechaAlta',
    // 'PropuestaImporte',
    'PropuestaFechaCierreEstimado',
    'Situacion',
    // 'Cotizaciones',
    'acciones'
  ];
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtros: any = {
    generico: '',
    entidad_razon_social: '',
    fecha_desde_carga: '',
    fecha_hasta_carga: '',
    fecha_desde_cierre: '',
    fecha_hasta_cierre: '',
    flujo_id: ''
  };
  title = "Propuestas";
  descargandolistado: boolean = false;
  cargando: boolean;
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  PropuestasDataSource = new MatTableDataSource();
  getClientesSuscripcion: Subscription;
  clientesCount: number = 0;
  cursos: any;
  tieneFiltrosOrdenPaginado = false;
  panelConFiltroActivo = false;
  total: number;
  situaciones:any=[{id:1,descripcion:'GANADA'},{id:2,descripcion:'PERDIDA'},{id:3,descripcion:'PENDIENTE'}];
  estados: any = [];
  public estados_propuestas = [];
  public listadoPropuestas = [];
  public idPropuesta: number;
  IdPropuesta: any;
  mostrar_archivados: boolean = false;
  //public acciones: AccionesPropuestaComponent;
  contador: any = {};
  ultimo_estado: any;
  flujo_actual = 1;
  inTransit: boolean;
  flujos = [];

  @ViewChild('onEntidadInput') onEntidadInput: AccionesPropuestaComponent;
  @ViewChild(MatSort) matSort: MatSort;
  @Input() prospecto_id: any; entidad_razon_social
  @Input() id_contacto: any;
  @Output() onHoraInput = new EventEmitter();
  @Input() filtrosExternos: any = { idPropuesta: 1 }; // filtros que se aplican según el lugar donde se muestran las incidencias
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 25);
    }
  };
  constructor
    (
      private _propuestasSv: PropuestasService,
      private _cmSv: ComunicacionService,
      private volverSv: VolverService,
      public dialog: MatDialog,
      private snackBar: MatSnackBar,
      private datePipe: FormatDatePipe,
      private router: Router,
    ) { }
  @Input('filtrado') filtrado: boolean = true;
  @Output() onAccionFinalizada = new EventEmitter();

  ngOnInit() {
    this.reiniciarPageState();
    this.traerEstadosPropuestas();
    this.traerFlujos();
    this.traerCursos();
  }

  propuestaDesarchivar(element) {
    let datos = {
      'IdPropuesta': element.IdPropuesta
    };
    this._propuestasSv.desarchivarPropuesta(
      datos
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          // this.dialogRef.close();
          this.actualizarTabla();
          this.snackBar.open("Propuesta desarchivada correctamente", 'OK', { duration: 2750 });
        }
      }
    );
  }

  propuestaArchivar(element: any) {
    // console.log(element);
    this.IdPropuesta = {
      IdPropuesta: element.IdPropuesta,
      estado: element.PropuestaEstado
    };

    // console.log(this.IdPropuesta);
    this._propuestasSv.archivarPropuesta(
      this.IdPropuesta
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          // this.dialogRef.close();
          this.actualizarTabla();
          this.snackBar.open("Propuesta archivada correctamente", 'OK', { duration: 2750 });
        }
      }
    );
  }

  verPerfilCliente(element: any) {
    // console.log(element);
    // Supongamos que el elemento contiene información relevante sobre el cliente,
    // como el ID del cliente o el nombre. Puedes usar esta información para construir la URL del perfil del cliente.
    if(element.entidades[0].IdEntidad == null || element.entidades[0].IdEntidad == ''){
      console.log('voy a contacto');
      let clienteId = element.contacto[0].IdContacto;
      this.router.navigate(['/logueado/contactos/contacto-detalle', clienteId]);
    }else{
      console.log('voy a cliente');
      let clienteId = element.entidades[0].IdEntidad;
      this.router.navigate(['/logueado/prospectos/prospecto-detalle/', clienteId]);
    }
  }

  traerFlujos() {
    this._propuestasSv.getFlujos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
    ).subscribe(
      respuesta => {
        // console.log(respuesta, "resp flujos");
        let _flujos = [];
        respuesta.data.forEach(element => {
          _flujos.push({
            id: element.id,
            descripcion: element.descripcion,
            cantidad_estados: element.cantidad
          })
        });
        // this.flujosDataSource.data = flujos;
        this.flujos = _flujos;

      },
      (err) => {
        console.log(err, "err");

      }
    )
  }


  traerCursos() {
    this._propuestasSv.getCursos(
      {
        page: null,
        estado_curso: 1
      },
    ).subscribe(
      respuesta => {
        let _cursos = [];
        respuesta.cursos.forEach(element => {
          _cursos.push({
            id: element.id,
            descripcion: element.descripcion,
            cantidad_estados: element.cantidad
          })
        });
        // this.cursosDataSource.data = cursos;
        this.cursos = _cursos;

      },
      (err) => {
        console.log(err, "err");

      }
    )
  }

  _limpiarPageState() {
    // filtros
    localStorage.setItem('ver_propuestas_filtros', null);
    // paginado
    localStorage.setItem('ver_propuestas_paginado', null);
    // sort
    localStorage.setItem('ver_propuestas_sort', null);
  }


  recordarPageState() {
    // filtros
    localStorage.setItem('ver_propuestas_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_propuestas_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_propuestas_sort', JSON.stringify(this.sort));
  }

  /**
   *
   * FUnciones de Drag an drop
   */
  colorProgreso(perc, min, max) {
    // console.log('perc',perc);
    // console.log('min', min);
    // console.log('max',max);

    var base = max - min;

    if (base == 0) {
      perc = 100;
    } else {
      perc = ((perc - min) / base) * 100;
    }
    var r,
      g,
      b = 0;

    if (perc < 50) {
      r = 255;
      g = Math.round(5.1 * perc);
    } else {
      g = 255;
      r = Math.round(510 - 5.1 * perc);
    }
    var h = r * 0x10000 + g * 0x100 + b * 0x1;
    return "#" + ("000000" + h.toString(16)).slice(-6);

  }

  traerEstadosPropuestas(): void {
    this.cargando = true;
    this._propuestasSv.getEstadosPropuestas({ 'filtros': { 'flujo_id': this.flujo_actual } }).subscribe(
      respuesta => {
        this.estados_propuestas = respuesta.estados;
        this.estados_propuestas.forEach(element => {
          this.contador[element.orden] = 0;
        });
        this.buscarUltimoEstado();
        this.obtenerTotal()
      }
    )
  }

  buscarUltimoEstado() {
    this.ultimo_estado = this.estados_propuestas[this.estados_propuestas.length - 1].id;
  }

  obtenerTotal(): void {

    this._propuestasSv.getPropuestas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          this.listadoPropuestas = respuesta.data;
          // this.listadoPropuestas.forEach(element => {
          //   this.contador[element.propuestaEstado.IdEstadoPropuesta]++;
          // });

        }
      }, () => {

      }, () => {

      });
  }

  colorEstado(propuesta) {
    switch (propuesta.PropuestaEstado) {
      case "1":
        return "badge badge--smaller";
      case "2":
        return "badge badge--smaller";
      case "3":
        return "badge badge--smaller";
      case "4":
        return propuesta.PropuestaIdSituacion == 1 ? "badge badge--success badge--smaller" : "badge badge--danger badge--smaller";
    }
  }

  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaModificacion' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    return this.tieneFiltrosOrdenPaginado;
  }
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_propuestas_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_propuestas_filtros'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_propuestas_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_propuestas_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('IdPropuesta', 'desc');
    }
    this.actualizarTabla();
  }
  /**
 * Para arreglar un bug de angular usamos esta funcion para ordenar
 */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_' + this.titulo + '_paginado_size', pageEvent.pageSize.toString());
    console.log('Aca esta el pageEvent', pageEvent);
    this.page = pageEvent;
    this.actualizarTabla();
  }


  reiniciarPageState() {
    this._limpiarPageState();
    this.restaurarPageState();
    this.actualizarTabla();
  }
  handleRefresh() {
    // Add logic to refresh the page or table
    // For example, you can reload the page
    // console.log('hola');
    this.matSort.sortChange.emit(this.matSort);

    // Refresh the rows
    this.PropuestasDataSource.data = this.PropuestasDataSource.data.slice();
  }
  total_importe: any;
  actualizarTabla(): void {
    this.cargando = true;
    this.mostrar_archivados = false;
    this.filtros['ver_archivadas'] = 0;
    // this.page.pageIndex = 0;
    // console.log('entidad_razon_social',this.filtros['entidad_razon_social']);
    // console.log('id_contacto',this.id_contacto);
    if (this.prospecto_id > 1)
      this.filtros['entidad_id'] = this.prospecto_id;
    if (this.id_contacto > 1)
      this.filtros['id_contacto'] = this.id_contacto;
    //this.filtros['nombre']='Cursos'
    this._propuestasSv.getPropuestas(
      {
        page: this.page.pageIndex,
        pageSize: this.page.pageSize
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    )
      .subscribe(
        respuesta => {
          // console.log('Propuestas', respuesta);

          this.cargando = false;
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.PropuestasDataSource.data = data.map(propuestas => {
              return propuestas
            });
            this.total = respuesta.total;
            this.total_importe = respuesta.total_importe;
          } else {
            this.PropuestasDataSource.data = []
          }
        },
        () => {
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        },
        () => {
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        }
      );
  }

  /**
  * Funcion para traer las propuestas
  */
  verArchivados(): void {
    this.cargando = true;
    this.PropuestasDataSource.data = [];
    this.mostrar_archivados = true;
    this.filtros['ver_archivadas'] = 1;
    this.filtros['panel'] = 1;
    this._propuestasSv
      .getPropuestas(
        {
          page: null,
          pageSize: null,
        },
        {
          sort: this.sort.active,
          order: this.sort.direction,
        },
        Object.assign(this.filtros)

      )
      .subscribe(
        (respuesta) => {
          if (respuesta.estado == 1 && respuesta.data) {
            this.PropuestasDataSource.data = respuesta.data;
          }
          this.cargando = false;
        },
        () => { },
        () => { }
      );
  }

  editarPropuesta(propuesta) {
    let dilogEditar = this.dialog.open(DialogAccionesPropuesta, {
      width: '70vw',
      data: { propuesta }
    });
    dilogEditar.afterClosed().subscribe(resultado => {
      this.reiniciarPageState();
    });
  }


  descargarListado() {
    this.descargandolistado = true;
    this.mostrar_archivados = false;
    this._propuestasSv.getPropuestas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtrosExternos, this.filtros)
    ).subscribe((data: any) => {
      const blobData = new Blob([data['archivo']], { type: 'text/csv' });
      saveAs(blobData, 'propuestas_listado.csv');
      this.descargandolistado = false;
    })
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }

  openDialog(propuesta?): void {
    const dialogRef = this.dialog.open(DialogAccionesPropuesta, {
      width: '70vw',
      data: { propuesta }
    });
    dialogRef.componentInstance.onCreado.subscribe(() => {
      this.onAccionFinalizada.emit();
    });
    dialogRef.afterClosed().subscribe(resultado => {
      this.onAccionFinalizada.emit();
      this.actualizarTabla();
    });
  }

  transform(value: any): string {
    return JSON.stringify(value, null, 2);
  }
}
